import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import baseURL from './url';
import { pedirBootstrap } from './DataContext';

const HorarioContext = createContext({ abierto: true, mensaje: '', loading: true });

export function HorarioProvider({ children }) {
    const [estado, setEstado] = useState({ abierto: true, mensaje: '', loading: true });

    const cargarDirecto = useCallback(() => {
        fetch(`${baseURL}/horarioEstadoGet.php`)
            .then(r => r.json())
            .then(d => setEstado({ abierto: !!d.abierto, mensaje: d.mensaje || '', loading: false }))
            .catch(() => setEstado({ abierto: true, mensaje: '', loading: false }));
    }, []);

    const cargar = useCallback(() => {
        pedirBootstrap()
            .then(data => {
                if (data?.horarioEstado) {
                    setEstado({
                        abierto: !!data.horarioEstado.abierto,
                        mensaje: data.horarioEstado.mensaje || '',
                        loading: false,
                    });
                } else {
                    cargarDirecto();
                }
            })
            .catch(() => cargarDirecto());
    }, [cargarDirecto]);

    useEffect(() => {
        cargar();
        const interval = setInterval(cargarDirecto, 120000);
        return () => clearInterval(interval);
    }, [cargar, cargarDirecto]);

    return (
        <HorarioContext.Provider value={estado}>
            {children}
        </HorarioContext.Provider>
    );
}

export function useHorario() {
    return useContext(HorarioContext);
}
